/**
 * Classe responsável por armazenar as informações dos cabeçalhos necessários para as conexões HTTP
 */
export class AxiosHeader {
    constructor(headers) {
        //Variável de Headers
        this._headers = [];
        this.headers = headers || [];
    }
    get headers() {
        return this._headers;
    }
    set headers(headers) {
        this._headers = headers;
    }
    //Adicionar novo header
    addHeader(key, value) {
        this.headers.push({ key, value });
    }
    //Remove um header existente
    removeHeader(key) {
        for (let i = 0; i < this.headers.length; i++) {
            if (this.headers[i].key === key) {
                this.headers.splice(i, 1);
            }
        }
    }
    //Constrói o AxiosHeaders de uma única vez com a propriedade addHeader
    buildHeader() {
        let headerAxios = {};
        this.headers.forEach(element => {
            headerAxios[element.key] = element.value;
        });
        return headerAxios;
    }
}
